import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import * as _ from "lodash";

@Injectable()
export class GeoServiceA2 {

    private baseUrl: string = '../rest';
    constructor (
        private http: Http
    ) {}


    getAirportsAndCities(nameLike, language) {
        let params = new URLSearchParams();
        params.append('nameLike', nameLike);
        params.append('language', language);
        return this.http.get(`${this.baseUrl}/geo/airportsAndCities`, {search: params})
            .map((response) => this.mapActions(response))
    }

    getCountries() {
         return this.http.get(`${this.baseUrl}/geo/countries`).map((response) => response.json());;
    }

    private mapActions(response:Response): string[]{
        let body = response.json();
        return _.map(body, (item) => {return {oid: item.locationOid, name:item.description,
            location:!item.location?{}:{latitude: item.location.latitude, longitude:item.location.longitude},
            typeReference:item.typeReference}}) || [];
    }


}


// WEBPACK FOOTER //
// ./public/upgrade/core/geo_a2.service.ts